const initialLayout = {
  elements: [],
};

export default initialLayout;
